import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BackendModule } from '@shared/datastore/core';
import { hourlyContractsBackend } from './hourly-contracts.backend';
import { hourlyContractsReducer } from './hourly-contracts.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('hourlyContracts', hourlyContractsReducer),
    BackendModule.forFeature('hourlyContracts', hourlyContractsBackend),
  ],
})
export class DatastoreHourlyContractsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/hourly-contracts/hourly-contracts.module.ts